import type { oz } from '@weft/utils';
import { DbCustomerEventSchema } from '../../entities';
import { ObjectIdSchema } from '../../primitives';

export const CustomerMatchedMessageSchema = DbCustomerEventSchema.extend({
  accountId: ObjectIdSchema,
});
  
export type CustomerMatchedMessage = oz.infer<typeof CustomerMatchedMessageSchema>;
